import React from 'react';

const common = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export function TutorialIcon(): React.ReactElement {
  return (
    <svg {...common}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.3 9.4a2.7 2.7 0 1 1 3.9 2.4c-.8.45-1.2 1-1.2 1.9v.3" />
      <circle cx="12" cy="16.9" r="0.15" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function TrophyIcon(): React.ReactElement {
  return (
    <svg {...common}>
      <path d="M7 4h10v5a5 5 0 0 1-10 0Z" />
      <path d="M7 5.5H4.5A2.5 2.5 0 0 0 7 9M17 5.5h2.5A2.5 2.5 0 0 1 17 9" />
      <path d="M12 14v3M9 20.5h6M9.5 20.5c0-2 .8-3 2.5-3s2.5 1 2.5 3" />
    </svg>
  );
}

export function PersonIcon(): React.ReactElement {
  return (
    <svg {...common}>
      <circle cx="12" cy="8.2" r="3.4" />
      <path d="M5 20c.7-3.8 3.4-6 7-6s6.3 2.2 7 6" />
    </svg>
  );
}
